/**
 * Stammdaten LCS GmbH und deren Marken für Briefköpfe, PDF-Generatoren
 * und E-Mail-Templates.
 *
 * Vertretungsberechtigt: Viktor Malinin (Issue #602)
 * Keine Telefon-/Fax-Felder — nur E-Mail laut Anweisung.
 */

export interface LcsBriefkopfData {
  anschrift: string;
  plz: string;
  ort: string;
  hrb_nr: string;
  ust_id: string;
  vertretungsberechtigt: string;
  footer_disclaimer: string;
}

export interface BriefkopfPreset {
  firmenname: string;
  zusatz: string;
  inhaber: string;
  titel: string;
  qualifikation: string;
  adresse: string;
  plz_ort: string;
  email: string;
  web: string;
  logo_url: string;
  bankname?: string;
  iban?: string;
  bic?: string;
  steuernummer?: string;
  ust_id?: string;
}

export const LCS_BRIEFKOPF: LcsBriefkopfData = {
  anschrift: 'Rahmedestraße 65, 58509 Lüdenscheid',
  plz: '58509',
  ort: 'Lüdenscheid',
  hrb_nr: '9443',
  ust_id: 'DE326350231',
  vertretungsberechtigt: 'Viktor Malinin',
  footer_disclaimer:
    'MietGo – eine Marke der LCS GmbH · Rahmedestraße 65 · 58509 Lüdenscheid · USt-ID DE326350231 · HRB 9443 · AG Iserlohn · Vertretungsberechtigt: Viktor Malinin · info@mietgo.de',
};

export const MIETGO_BRIEFKOPF: BriefkopfPreset = {
  firmenname: 'MietGo — eine Marke der LCS GmbH',
  zusatz: 'MietGo',
  inhaber: 'Viktor Malinin',
  titel: 'Vertretungsberechtigt: Viktor Malinin',
  qualifikation: 'Unfallersatzfahrzeuge & Forderungsmanagement',
  adresse: 'Rahmedestraße 65',
  plz_ort: '58509 Lüdenscheid',
  email: 'info@mietgo.de',
  web: 'mietgo.de',
  logo_url: '/logos/mietgo-logo-dark.png',
  bankname: 'Sparkasse an Volme und Ruhr',
  iban: 'DE33 4505 0001 0000 4251 08',
  bic: 'WELADE3HXXX',
  steuernummer: '332/5745/1628',
  ust_id: 'DE326350231',
};

export const LENNEGLAS_BRIEFKOPF: BriefkopfPreset = {
  firmenname: 'Lenneglas — eine Marke der LCS GmbH',
  zusatz: 'Lenneglas',
  inhaber: 'Viktor Malinin',
  titel: 'Vertretungsberechtigt: Viktor Malinin',
  qualifikation: 'Autoglasmontage & Reparatur',
  adresse: 'Rahmedestraße 65',
  plz_ort: '58509 Lüdenscheid',
  email: 'info@lenneglas.de',
  web: 'lenneglas.de',
  logo_url: '/logos/lenneglas-logo.webp',
};

export const LCS_GMBH_BRIEFKOPF: BriefkopfPreset = {
  firmenname: 'LCS GmbH',
  zusatz: 'LCS GmbH',
  inhaber: 'Viktor Malinin',
  titel: 'Vertretungsberechtigt: Viktor Malinin',
  qualifikation: 'Mietwagen & Dienstleistungen',
  adresse: 'Rahmedestraße 65',
  plz_ort: '58509 Lüdenscheid',
  email: 'info@lcs-gmbh.de',
  web: 'lcs-gmbh.de',
  logo_url: '/logos/mietgo-logo-dark.png',
  bankname: 'Sparkasse an Volme und Ruhr',
  iban: 'DE33 4505 0001 0000 4251 08',
  bic: 'WELADE3HXXX',
  steuernummer: '332/5745/1628',
  ust_id: 'DE326350231',
};
